import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup } from "effect/unstable/httpapi";
import { HistoryHttpErrorResponses } from "../errors/http.ts";
import { WorkspaceHistoryListQuery, WorkspaceHistoryListResponse, WorkspaceHistoryReadResponse, WorkspaceHistoryRestoreResponse, WorkspaceRevisionRestoreBody } from "./workspace.ts";

// Wire text is normalized and branded by the history request decoder. Keeping
// text here preserves its compatibility diagnostics and non-decimal revisions.
export const WorkspaceHistoryApi = HttpApiGroup.make("workspaceHistory").add(
  HttpApiEndpoint.get("list", "/api/history/workspaces/:workspaceId/revisions", {
    params: Schema.Struct({ workspaceId: Schema.String }),
    query: WorkspaceHistoryListQuery,
    success: WorkspaceHistoryListResponse, error: HistoryHttpErrorResponses
  }),
  HttpApiEndpoint.get("read", "/api/history/workspaces/:workspaceId/revisions/:revisionId", {
    params: Schema.Struct({ workspaceId: Schema.String, revisionId: Schema.String }),
    success: WorkspaceHistoryReadResponse, error: HistoryHttpErrorResponses
  }),
  HttpApiEndpoint.post("restore", "/api/history/workspaces/:workspaceId/revisions/:revisionId/restore", {
    params: Schema.Struct({ workspaceId: Schema.String, revisionId: Schema.String }),
    payload: WorkspaceRevisionRestoreBody,
    success: WorkspaceHistoryRestoreResponse, error: HistoryHttpErrorResponses
  })
);
